import React from 'react';
import PageHeader from '../components/PageHeader';

const sections = [
  {
    icon: 'fa-info-circle',
    title: 'Information We Collect',
    content: [
      'Personal identification information (name, email address, phone number)',
      'Professional information (resume, work experience, skills, education)',
      'Account credentials and profile data',
      'Usage data including pages visited, time spent, and interactions',
      'Device and browser information for security and analytics purposes',
    ],
  },
  {
    icon: 'fa-cogs',
    title: 'How We Use Your Information',
    content: [
      'To create and manage your JobEntry account',
      'To match job seekers with relevant job opportunities',
      'To allow employers to review candidate profiles and applications',
      'To send job alerts, newsletters, and platform updates (with your consent)',
      'To improve our platform features and user experience',
      'To comply with legal obligations and prevent fraudulent activity',
    ],
  },
  {
    icon: 'fa-share-alt',
    title: 'Information Sharing',
    content: [
      'We do not sell your personal data to third parties',
      'Employer profiles and job listings are visible to registered job seekers',
      'Job seeker profiles are shared with employers only when you apply',
      'We may share data with trusted service providers under strict confidentiality agreements',
      'We may disclose information if required by law or to protect our legal rights',
    ],
  },
  {
    icon: 'fa-shield-alt',
    title: 'Data Security',
    content: [
      'All data is encrypted in transit using SSL/TLS protocols',
      'Passwords are hashed and never stored in plain text',
      'We conduct regular security audits and vulnerability assessments',
      'Access to personal data is restricted to authorized personnel only',
      'In the event of a data breach, we will notify affected users promptly',
    ],
  },
  {
    icon: 'fa-user-check',
    title: 'Your Rights',
    content: [
      'Access and download a copy of your personal data at any time',
      'Request correction of inaccurate or incomplete information',
      'Request deletion of your account and associated data',
      'Opt out of marketing communications at any time',
      'Lodge a complaint with the relevant data protection authority',
    ],
  },
  {
    icon: 'fa-cookie-bite',
    title: 'Cookies Policy',
    content: [
      'We use essential cookies to keep you logged in and secure',
      'Analytics cookies help us understand how users interact with our platform',
      'You can manage cookie preferences through your browser settings',
      'Disabling cookies may affect some features of the platform',
    ],
  },
];

export default function PrivacyPolicy() {
  return (
    <>
      <PageHeader title="Privacy Policy" breadcrumb="Privacy Policy" />
      <section className="section-pad">
        <div className="container" style={{ maxWidth: 860 }}>

          <div className="policy-intro">
            <div className="policy-intro-icon"><i className="fa fa-lock"></i></div>
            <div>
              <h4>Your Privacy Matters to Us</h4>
              <p>
                At <strong>JustHiring24</strong> (operated by Onexvora Business Solutions), we are committed to protecting your personal information.
                This policy explains what data we collect, how we use it, and your rights regarding your information.
                Last updated: <strong>January 1, 2025</strong>.
              </p>
            </div>
          </div>

          {sections.map((s, i) => (
            <div className="policy-section" key={i}>
              <div className="policy-section-title">
                <div className="policy-section-icon"><i className={`fa ${s.icon}`}></i></div>
                <h5>{s.title}</h5>
              </div>
              <ul className="policy-list">
                {s.content.map((item, j) => (
                  <li key={j}><i className="fa fa-check-circle"></i><span>{item}</span></li>
                ))}
              </ul>
            </div>
          ))}

          <div className="policy-contact-box">
            <i className="fa fa-envelope"></i>
            <div>
              <h6>Questions about this policy?</h6>
              <p>Contact us at <a href="mailto:onexverabusinesssolutions@gmail.com">onexverabusinesssolutions@gmail.com</a> or write to us at D-184, Sector-63, Noida, UP - 201301.</p>
            </div>
          </div>

        </div>
      </section>
    </>
  );
}
